import { gql } from '@apollo/client'

export const GET_CHECKOUT_SESSION = gql`
    query BookingCreateAdyenSession(
        $id: Int!
        $shopper_email: String!
        $shopper_locale: String!
        $top_level_domain: String!
    ) {
        booking_create_adyen_session(
            id: $id
            shopper_email: $shopper_email
            shopper_locale: $shopper_locale
            top_level_domain: $top_level_domain
        ) {
            session_data
            session_id
        }
    }
`
